import { ErrorBox } from "../shared/error-box";
import { getErrorMessage } from "./utils";

/**
 * @param extraInfo - Extra information to display in the error message
 */
export function ServiceUnavailable({ extraInfo }: { extraInfo?: string }) {
  return <ErrorBox>{getErrorMessage("service unavailable", extraInfo)}</ErrorBox>;
}
